//
// Export all the services.
//
export {
    TranslationsService,
    NotificationsService
} from './services';

//
// Export all the components.
//
export {
    FormControlComponent,
    CheckboxComponent,
    RadioComponent,
    SelectComponent,
    ButtonComponent,
    ButtonGroupComponent,
    CardComponent,
    ModalComponent,
    DatePickerComponent,
    TableComponent
} from './components';

//
// Export all the pipes.
//
export {
    TranslatePipe
} from './pipes';

//
// Export all the directives.
//
export {
    ClickOutsideDirective
} from './directives';

//
// Export all the interfaces.
//
export {
    LibraryConfig,
    Option,
    CardEvent,
    CardButton,
    TableRow,
    Notification
} from './interfaces';

//
// Export the library module.
//
export {
    NgxManagerModule
} from './ngx-manager.module';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/index.ts